import React from 'react';

interface GriefHeartIconProps {
  fill?: string;
  className?: string;
}

export const GriefHeartIcon: React.FC<GriefHeartIconProps> = ({ fill = '#85ADAA', className = '' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="82" height="73" viewBox="0 0 82 73" fill="none" className={className}>
    <g clipPath="url(#grief-heart-clip)">
      <path
        d="M21.6681 6.50791C17.6332 6.50791 13.8312 8.09721 10.9677 10.9812C5.02842 16.9685 5.02842 26.7098 10.9677 32.6971L40.8151 62.7842L70.6555 32.6971C76.5948 26.7098 76.5948 16.9685 70.6555 10.9812C67.7989 8.09721 63.9969 6.50791 59.962 6.50791C55.9271 6.50791 52.1251 8.09721 49.2616 10.9812L45.4322 14.8449L40.8082 19.5032L36.1842 14.8449L32.3548 10.9812C29.4981 8.09721 25.6962 6.50791 21.6613 6.50791M21.6681 0C27.2101 0 32.7521 2.13048 36.9857 6.3983L40.8151 10.2619L44.6444 6.3983C48.8712 2.13048 54.4131 0 59.962 0C65.5108 0 71.046 2.13048 75.2727 6.3983C83.7398 14.9271 83.7398 28.7512 75.2727 37.28L40.8082 72.0254L6.3437 37.28C-2.12343 28.7512 -2.12343 14.9271 6.3437 6.3983C10.5773 2.13733 16.1193 0 21.6613 0L21.6681 0Z"
        fill={fill}
      />
      <line
        y1="-3.025"
        x2="37.8278"
        y2="-3.025"
        transform="matrix(-0.545087 0.83838 -0.813989 -0.58088 38.5684 11.937)"
        stroke={fill}
        strokeWidth="6.05"
      />
      <line x1="38.5784" y1="13.6786" x2="12.8367" y2="36.8082" stroke={fill} strokeWidth="6.05" />
      <line x1="29.8691" y1="6.9287" x2="10.7475" y2="33.0051" stroke={fill} strokeWidth="6.05" />
    </g>
    <defs>
      <clipPath id="grief-heart-clip">
        <rect width="81.6228" height="72.0254" fill="white" transform="matrix(-1 0 0 1 81.623 0)" />
      </clipPath>
    </defs>
  </svg>
);
